import { render, staticRenderFns } from "./ExpedicaoRowActions.vue?vue&type=template&id=1453c6b8"
import script from "./ExpedicaoRowActions.vue?vue&type=script&lang=js"
export * from "./ExpedicaoRowActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports